import Loadable from '../../components/loadable';

const GenerateIframeModal = Loadable({
  loader: () => import('../../pages/manage_website/generate_iframe_modal'),
  type: 'modal',
});

angular.module('gym').value('GenerateIframeModal', GenerateIframeModal);
